module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/1_35e3986445c3e9b2de82f8bf0cd797b0.png";